<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'
</script>

<template>
  <ConfirmModal>
    <template #title>Do you want to send lineup without captain?</template>
  </ConfirmModal>
</template>
